import { KnowledgeBasesTable } from "@/components/KnowledgeBases/KnowledgeBasesTable";

const KnowledgeBasesWorkshop = () => {
  return (
    <div className="w-full flex flex-col flex-1 pb-5">
      <KnowledgeBasesTable />
    </div>
  );
};

export default KnowledgeBasesWorkshop;
